import { render } from "./TestResultTips.vue?vue&type=template&id=c68aa0f0&scoped=true"
import script from "./TestResultTips.vue?vue&type=script&lang=js"
export * from "./TestResultTips.vue?vue&type=script&lang=js"

import "./TestResultTips.vue?vue&type=style&index=0&id=c68aa0f0&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68aa0f0"]])

export default __exports__